import styled, { keyframes } from "styled-components";

const spin = keyframes`to { transform: rotate(360deg); }`;

const Ring = styled.span`
  display: inline-block;
  width: ${(p) => p.$size}px;
  height: ${(p) => p.$size}px;
  border: 2px solid ${(p) => p.$color};
  border-top-color: transparent;
  border-radius: 50%;
  animation: ${spin} 0.6s linear infinite;
`;

// ponytail: drop-in for react-spinners MoonLoader — same props, plain CSS ring
const Spinner = ({ size = 22, color = "#292359", loading = true, cssOverride }) =>
  loading ? <Ring $size={size} $color={color} style={cssOverride} /> : null;

export default Spinner;
